import React, {FC} from "react"
import styled from "styled-components"

import {Label2} from "@irati/ui/src/Labels"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import ProfilePicture from "@irati/ui/src/ProfilePicture"
import {User} from "@irati/types"

const Wrapper = styled.div`
  margin-bottom: 10px;
  text-align: left;
`

interface Props {
  createdBy: User,
  bold?: boolean
}

const WhoCreated: FC<Props> = ({createdBy, bold}) => {
  return (
    <Wrapper>
      <ProfilePicture user={createdBy} marginRight small />
      <Label2 bold={bold}>{firstnameLastname(createdBy)}</Label2>
    </Wrapper>
  )
}

export default WhoCreated
